import { MimeTypes } from '_constants'

export const getFileUrl = (
  blob: string | Blob | undefined,
  format: MimeTypes = MimeTypes.PDF
): string | undefined => {
  // Create blob link to download or preview
  return blob && URL.createObjectURL(new Blob([blob], { type: format }))
}
